const analytics = {
  /**
   * @param {Object} event
   */
  sendEvent(event) {
    if (!event) return

    if (!Array.isArray(window.dataLayer)) {
      window.dataLayer = []
    }

    const userID = window.elama_user_id
    if (userID) {
      Object.assign(event, { user_id: userID }) // eslint-disable-line
    }

    window.dataLayer.push(event)
  }
}

export default analytics
